import React, { useCallback } from "react";
import PropTypes from "prop-types";

export const AttachmentUpload = React.forwardRef(({ onUpload, ...rest }, ref) => {
  const handleChange = useCallback(
    (event) => {
      if (typeof onUpload === "function" && event.target.files.length) {
        const files = Array.from(event.target.files);
        files.forEach((file) => onUpload(file));
        event.target.value = "";
      }
    },
    [onUpload]
  );

  return (
    <input
      {...rest}
      ref={ref}
      type="file"
      onChange={handleChange}
      className="attachment-upload"
      tabIndex={-1}
      data-testid="file-upload-input"
    />
  );
});

AttachmentUpload.propTypes = {
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
};

AttachmentUpload.displayName = "AttachmentUpload";
